import type { AppState } from '../rootReducer';

export const isAlreadyFetchedOnce = (state: AppState) =>
  state.paymentMethods.isAlreadyFetchedOnce;

export const canAddNewPaymentMethod = (state: AppState) =>
  state.paymentMethods.canAddNewPaymentMethod;
